import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';

declare var $: any;

@Component({
  selector: 'app-brows-by-application',
  templateUrl: './brows-by-application.component.html',
  styleUrls: ['./brows-by-application.component.scss']

})
export class BrowsByApplicationComponent implements OnInit, OnDestroy {
  applicationList: any[] = [];
  allApplicationList: any;
  applicationListAll: any;
  filterData: any =[];
  isMobile: boolean = false;
  finalData: any =[];

  environment1 =environment.s3bucket.url;
  constructor(private apiService: ApiService, private toastService: ToastrService,private router:Router,private behaviourSubject: BehaviourSubjectService,
    @Inject(PLATFORM_ID) private platformId: Object,) { }
  sub: Subscription = new Subscription();
  searchData:any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
        this.getBrowseByApp('5')

      } else {
        this.isMobile = false;
        this.getBrowseByApp('9')

      }
    }
  }
  getBrowseByApp(limit:any) {
    

      let formData = new FormData();
      formData.append("action_type", "get")
      formData.append("limit", '100')

      try {
        this.sub.add(this.apiService.getBrowseByApplication(formData).subscribe(
          (res) => {
            if (res.success) {
              if(limit==9 || limit==5){
                this.applicationList = res.data;

                  this.applicationList.forEach(element => {
                  if(element.vehicle_application_name?.toLowerCase() =='e-commerce'){
                  this.finalData[0] = element;
                  this.applicationList.splice(1,1,element)
                  }
                  if(element.vehicle_application_name?.toLowerCase() =='fruits & vegetables'){
                    this.finalData[1] = element;

                  }
                  if(element.vehicle_application_name?.toLowerCase() =='courier and parcel'){
                    this.finalData[2]=element;

                  }
                  if(element.vehicle_application_name?.toLowerCase() =='fmcg'){
                    this.finalData[3]=element;
                  }
                  if(element.vehicle_application_name?.toLowerCase() =='market load operators'){
                    this.finalData[4]=element;

                  } if(limit == '9'){
                  if(element.vehicle_application_name?.toLowerCase() =='milk & dairy'){
                    this.finalData[5]=element;

                  }
                  if(element.vehicle_application_name?.toLowerCase() =='ambulance'){
                    this.finalData[6]=element;

                  }
                  if(element.vehicle_application_name?.toLowerCase() =='auto logistics'){
                    this.finalData[7]=element;

                  }
                  // if(element.vehicle_application_name.toLowerCase() =='school contractor'){
                  //   this.finalData[8]=element;

                  // }
                }

                });

              this.finalData.push({"created_date": "2023-12-05T09:32:19.043195Z",
                "id":235,
                "image_path":"https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/VehicleApplicationImages/3694.webp"
                ,"vehicle_application_name":"View All"})

              }
              else{
                this.applicationListAll = res.data;
                this.filterData = this.applicationListAll;


              }
            }
            else {
              this.applicationListAll = [];
              this.filterData = [];
            }
          },
          () => {
          }
        ))
      }
      catch (err) {
        this.toastService.warning();

      }
    
  }
  onValueSelection(value:any){
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem('ExploreMappedDatatype')
    localStorage.removeItem('ExploreMappedDatamodal')
    localStorage.removeItem("explore")
    localStorage.removeItem("EModeldData")
    }
    let vehicle_application=value.target.value
    this.router.navigate(['product-list'], { queryParams: { vehicle_application} });
  }

  redirect(item:any){
    if (isPlatformBrowser(this.platformId)) {
    let vehicle_application=item
    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem('ExploreMappedDatatype')
    localStorage.removeItem('ExploreMappedDatamodal')
    localStorage.removeItem("explore")
    localStorage.removeItem("EModeldData")
    if(item == 'View All'){
      this.imagePreviewpopup();
      this.getBrowseByApp('100');
    }
    else{
      $('#imageFullScreenModeModal').modal('hide');

    this.router.navigate(['product-list'], { queryParams: { vehicle_application} });
    }
    localStorage.removeItem('searchValue')
    this.behaviourSubject.isFilterChange.next(false)
    this.behaviourSubject.isClearfilter.next(false)
  }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  imagePreviewpopup() {
    $('#imageFullScreenModeModal').modal('show', function () { });
  }

  imagePreviewpopupClose(){
    $('#imageFullScreenModeModal').modal('hide');
    this.searchData='';
    this.filterData = [];
  }

  search(data:string){
    let a:string;
    this.filterData = [];

    this.applicationListAll.filter((d:any)=>{
       a = d['vehicle_application_name']
      if((a?.toLowerCase()).startsWith(data?.toLowerCase())){
        this.filterData.push(d);
      }
    })
    if(this.filterData?.length == 0 && data?.length >0){
      this.filterData = [];
    }
    if(data?.length == 0)
    {
      this.filterData = this.applicationListAll;
    }
  }
}
